/* istanbul ignore file */
import styled, { css } from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { SPACES, PADDING } from 'common/constants/sizes';
import { isBlurredSelector } from 'state/selectors/ui-state';
import { connect } from 'react-redux';

const page = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  ${({ isBlurred }) =>
    isBlurred
      ? `
      filter: blur(5px);
      pointer-events: none;`
      : ''}
`;

export const Page = connect(state => ({
  isBlurred: state ? isBlurredSelector(state) : false
}))(page);

export const GrayBackground = styled.div`
  flex-grow: 1;
  background-color: ${getColor('catskillWhite')};
`;

/* eslint-disable jsdoc/require-param,jsdoc/require-returns,jsdoc/check-alignment */
/**
 * @deprecated Please use MUI's `<Card>` or `<Box>` components
 */
export const WhiteSection = styled.div`
  background-color: ${getColor('white')};
  box-sizing: border-box;
  ${({ padding }) => (padding ? `padding: ${padding}` : null)};
  ${({ t }) => (t ? `padding-top: ${t}` : null)};
  ${({ r }) => (r ? `padding-right: ${r}` : null)};
  ${({ l }) => (l ? `padding-left: ${l}` : null)};
  ${({ b }) => (b ? `padding-bottom: ${b}` : null)};
  ${({ margin }) => (margin ? `margin: ${margin}` : null)};
  ${({ ml }) => (ml ? `margin-left: ${ml}` : '')};
  ${({ mr }) => (mr ? `margin-right: ${mr}` : '')};
  ${({ mt }) => (mt ? `margin-top: ${mt}` : '')};
  ${({ mb }) => (mb ? `margin-bottom: ${mb}` : '')};
  ${({ width }) => (width ? `width: ${width}` : '')};
  ${({ height }) => (height ? `height: ${height}` : '')};
  ${({ minHeight }) => (minHeight ? `min-height: ${minHeight}` : '')};
  ${({ display }) => `display: ${display ? display : 'block'}`};
  ${({ borderRadius }) =>
    borderRadius ? `border-radius: ${borderRadius}` : 'border-radius: 2px'};
  ${({ borderRight }) => (borderRight ? `border-right: ${borderRight}` : '')};
`;

export const Separator = styled.div`
  ${({ direction }) =>
    `display: ${direction === 'horizontal' ? 'block' : 'inline-block'}`};
  ${({ color }) =>
    `background-color: ${color ? color : getColor('botticelli')}`};
  ${({ width }) => `width: ${width ? width : '1px'}`};
  ${({ height }) => `height: ${height ? height : '1.2rem'}`};
  ${({ margin }) => `margin: ${margin ? margin : ''}`};
  ${({ padding }) => `padding: ${padding ? padding : ''}`};
`;

/* eslint-disable jsdoc/require-param,jsdoc/require-returns,jsdoc/check-alignment */
/**
 * @deprecated Please use MUI's spacing variables
 */
export const Padding = styled.div`
  ${({ padding }) => (padding ? `padding: ${SPACES[padding]}` : '')};
  ${({ l }) => (l ? `padding-left: ${SPACES[l]}` : '')};
  ${({ r }) => (r ? `padding-right: ${SPACES[r]}` : '')};
  ${({ t }) => (t ? `padding-top: ${SPACES[t]}` : '')};
  ${({ b }) => (b ? `padding-bottom: ${SPACES[b]}` : '')};
  ${({ box }) => (box ? `box-sizing: ${box}` : '')};
  ${({ width }) => (width ? `width: ${width}` : '')};
  ${({ height }) => (height ? `height: ${height}` : '')};
  box-sizing: content-box;
`;

export const Margin = styled.div`
  ${({ l }) => (l ? `margin-left: ${SPACES[l]}` : '')};
  ${({ r }) => (r ? `margin-right: ${SPACES[r]}` : '')};
  ${({ t }) => (t ? `margin-top: ${SPACES[t]}` : '')};
  ${({ b }) => (b ? `margin-bottom: ${SPACES[b]}` : '')};
  ${({ margin }) => (margin ? `margin: ${SPACES[margin]}` : '')};
  ${({ width }) => (width ? `width: ${width}` : '')};
  ${({ height }) => (height ? `height: ${height}` : '')};
`;

/* eslint-disable jsdoc/require-param,jsdoc/require-returns,jsdoc/check-alignment */
/**
 * @deprecated If you need a flex-box component use `<Stack>` or `<Grid>` from '@mui/material'
 */
export const Flex = styled.div`
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  ${({ borderBox }) =>
    borderBox ? 'box-sizing: border-box;' : 'box-sizing: content-box;'};
  ${({ flex }) => (flex ? `flex: ${flex};` : '')};
  ${({ direction }) => (direction ? `flex-direction: ${direction}` : '')};
  ${({ position }) => (position ? `position: ${position}` : '')};
  ${({ grow }) => (grow ? `flex-grow: ${grow}` : '')};
  ${({ justify }) => (justify ? `justify-content: ${justify}` : '')};
  ${({ items }) => (items ? `align-items: ${items}` : '')};
  ${({ self }) => (self ? `align-self: ${self}` : '')};
  ${({ justifySelf }) => (justifySelf ? `justify-self: ${justifySelf}` : '')};
  ${({ content }) => (content ? `align-content: ${content}` : '')};
  ${({ basis }) => (basis ? `flex-basis: ${basis}` : '')};
  ${({ height }) => (height ? `height: ${height}` : '')};
  ${({ minHeight }) => (minHeight ? `min-height: ${minHeight}` : '')};
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}` : '')};
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}` : '')};
  ${({ maxHeight }) => (maxHeight ? `max-height: ${maxHeight}` : '')};
  ${({ width }) => (width ? `width: ${width}` : '')};
  ${({ wrap }) => (wrap ? `flex-wrap: ${wrap}` : '')};
  ${({ visibility }) => (visibility ? `visibility: ${visibility}` : '')};
  ${({ padding }) =>
    padding
      ? `padding: ${SPACES[padding] || PADDING[padding] || padding}`
      : ''};
  ${({ pl }) => (pl ? `padding-left: ${SPACES[pl] || pl}` : '')};
  ${({ pr }) => (pr ? `padding-right: ${SPACES[pr] || pr}` : '')};
  ${({ pt }) => (pt ? `padding-top: ${SPACES[pt] || pt}` : '')};
  ${({ pb }) => (pb ? `padding-bottom: ${SPACES[pb] || pb}` : '')};
  ${({ margin }) => (margin ? `margin: ${SPACES[margin] || margin}` : '')};
  ${({ ml }) => (ml ? `margin-left: ${SPACES[ml] || ml}` : '')};
  ${({ mr }) => (mr ? `margin-right: ${SPACES[mr] || mr}` : '')};
  ${({ mt }) => (mt ? `margin-top: ${SPACES[mt] || mt}` : '')};
  ${({ mb }) => (mb ? `margin-bottom: ${SPACES[mb] || mb}` : '')};
  ${({ cursor }) => (cursor ? `cursor: ${cursor}` : '')};
  ${({ overflow }) => (overflow ? `overflow: ${overflow}` : '')};
  ${({ overflowY }) => (overflowY ? `overflow-y: ${overflowY}` : '')};
  ${({ overflowX }) => (overflowX ? `overflow-x: ${overflowX}` : '')};
  ${({ borderTop }) => (borderTop ? `border-top: ${borderTop}` : '')};
  ${({ borderBottom }) =>
    borderBottom ? `border-bottom: ${borderBottom}` : ''};
  ${({ borderLeft }) => (borderLeft ? `border-left: ${borderLeft}` : '')};
  ${({ borderRight }) => (borderRight ? `border-right: ${borderRight}` : '')};
  ${({ border }) => (border ? `border: ${border}` : '')};
  ${({ borderRadius }) =>
    borderRadius ? `border-radius: ${borderRadius}` : ''};
  ${({ invisible }) => (invisible ? `visibility: hidden` : '')};
  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${backgroundColor}` : ''};
  ${({ color }) => (color ? `color: ${getColor(color)}` : '')};
  ${({ background }) => (background ? `background: ${background}` : '')};
  ${({ gap }) => (gap ? `gap: ${gap}` : '')};
  ${({ opacity }) => (opacity ? `opacity: ${opacity}` : '')};
`;

export const DarkBlueWrapper = styled(Flex)`
  background-color: ${getColor('darkBlue')};

  * {
    box-sizing: content-box;
  }
`;

export const TagWrapper = styled(Flex)`
  align-items: center;
  padding: 0.2rem 0.4rem;
  margin-right: 0.6rem;
  width: fit-content;
  border-radius: 0.2rem;
  ${({ borderColor }) => `border: 1px solid ${getColor(borderColor)};`}
  ${({ backgroundColor }) => `background: ${getColor(backgroundColor)};`}
`;

export const StyledCode = styled.code`
  ${({ radius }) => `border-radius: ${radius ? radius : '3px'};`}
  ${({ backgroundColor }) =>
    `background-color: ${getColor(
      backgroundColor ? backgroundColor : 'catskillGray'
    )};`}
  display: inline-block;
  ${({ padding }) => `padding: ${padding ? padding : '2px 6px 6px'};`}
  ${({ margin }) => `margin: ${margin ? margin : '0 0.5rem 0.8rem 0'};`}
`;

export const TableNoVerticalLines = styled.div`
  .MuiTableHead-root > .MuiTableRow-head:first-child {
    border-top: 0;
  }

  .MuiTableHead-root .MuiTableCell-head,
  .MuiTableBody-root .MuiTableCell-body {
    border-left: 0;
    border-right: 0;
  }
`;

export const TableNoVerticalLinesAndNoFirstAndLastBorder = styled.div`
  .MuiTableHead-root > .MuiTableRow-head:first-child {
    border-top: 0;
  }

  .MuiTableBody-root > .MuiTableRow-root:last-child > .MuiTableCell-root {
    border-bottom: 0;
  }

  .MuiTableHead-root .MuiTableCell-head,
  .MuiTableBody-root .MuiTableCell-body {
    border-left: 0;
    border-right: 0;
  }
`;

export const InputWrapper = styled(Flex)`
  flex-grow: 1;
  display: flex;

  & > div {
    flex-grow: 1;
    padding-right: 1rem;
    width: 100%;
    display: flex;
  }
`;

export const BadgeWrapper = styled(Flex)`
  background-color: ${getColor('fog')};
  padding: 0.2rem 0.4rem;
  ${({ isNotAbsolute }) => (isNotAbsolute ? '' : `position: absolute;`)};
  ${({ right }) => `right: ${right ? right : 0};`};
  ${({ color }) => (color ? `color: ${getColor(color)};` : '')};
  ${({ margin }) => (margin ? `margin: ${margin};` : '')};
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
`;

export const TableNoVerticalSpacesCss = css`
  .MuiTableHead-root .MuiTableCell-root {
    padding-top: 0;
    padding-bottom: 0;
  }

  .MuiTableBody-root .MuiTableCell-root {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const TableNoVerticalSpaces = styled.div`
  ${TableNoVerticalSpacesCss}
`;

export const TableNoLeftRightBorders = styled.div`
  .MuiTableHead-root > .MuiTableRow-head:first-child {
    border-top: 0;
  }

  .MuiTableHead-root .MuiTableCell-head {
    border-left: 0;
    border-right: 0;
  }

  .MuiTableBody-root .MuiTableCell-body {
    border-left: 0;
    border-right: 0;
  }
`;

export const IconLinkWrapper = styled(Flex)`
  cursor: pointer;

  :hover {
    svg > path:nth-of-type(1) {
      fill: ${getColor('dodgerBlue')};
    }

    svg > path:nth-of-type(2) {
      stroke: ${getColor('dodgerBlue')};
    }
  }
`;

export const LegendSymbol = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  ${({ backgroundColor }) => `background-color: ${backgroundColor}`};
`;

export const unselectable = () => `-webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
       -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Old versions of Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
  `;

export const TooltipStyled = styled.div`
  ${({ padding }) => (padding ? `padding: ${padding}` : null)};
  ${({ width }) => (width ? `width: ${width}` : null)};
  border: 1px solid ${getColor('botticelli')};
  box-sizing: border-box;
  filter: drop-shadow(0px 0px 20px rgba(33, 47, 77, 0.15));
  border-radius: 4px;
  background: ${getColor('white')};
`;

export const PageLayout = ({ children }) => {
  return (
    <Page>
      <GrayBackground style={{ padding: SPACES.small }}>
        {children}
      </GrayBackground>
    </Page>
  );
};
